import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// import flexible from "amfe-flexible";
import "../src/utils/rem.js";
import cookie from "js-cookie";
import zhCn from "element-plus/es/locale/lang/zh-cn";

createApp(App).use(store).use(router).use(cookie).use(ElementPlus, { locale: zhCn }).mount("#app");
